exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-confirm-order .dropdown-item {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n.btn-confirm-order .dropdown-menu > a:hover, .btn-confirm-order > li > a:hover {\n  background-image: none;\n  background-color: #209eea;\n}\n\n.membership-actions {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 20px;\n  gap: 15px;\n}", ""]);

// exports
